import FileUploadModal from 'components/molecules/csvUploadModal';
import { INACTIVE_PATIENT_CLEANUP } from 'services/dataService/resources';
import dataService from 'services/dataService';
import { downloadCSV } from 'utils';
import { useTranslation } from 'react-i18next';
import { showResult } from 'infrastructure/hooks/utils';

import type { FC } from 'react';

interface Props {
  isOpen: boolean;
  toggle: () => void;
}

const InactivePatientCleanupModal: FC<Props> = ({ isOpen, toggle }) => {
  const { t } = useTranslation();
  const uploadCsvFile = async (file: File) => {
    const formData = new FormData();
    formData.append('file', file);

    const { error, data } = await dataService.uploadFile(
      INACTIVE_PATIENT_CLEANUP,
      formData,
    );

    if (error) {
      showResult(error);
    }

    if (data) {
      downloadCSV(data, `${file.name}_inactivePatientCleanupResult.txt`);
      if (toggle) {
        toggle();
      }
    }
    return {};
  };

  return (
    <FileUploadModal
      isOpen={isOpen}
      toggle={toggle}
      title={t('adminTools.inactivePatientCleanup')}
      sampleFileUrl="/csvTemplates/inactivePatientCleanupTemplate.csv"
      uploadCsvFile={uploadCsvFile}
    />
  );
};

export default InactivePatientCleanupModal;
